import { render, staticRenderFns } from "./AddressNew.vue?vue&type=template&id=520d4e0e"
import script from "./AddressNew.vue?vue&type=script&lang=js"
export * from "./AddressNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports